import cx from 'classnames';
import type {KeyboardEvent} from 'react';
import React, {useRef} from 'react';

import {focusMenuItem} from './menuKeyboard';

interface MenuStaticProps extends PropsWithChildrenRequired, PropsWithClassNameOptional {}

const MenuStatic = ({children, className = ''}: MenuStaticProps) => {
  const menuRef = useRef<HTMLDivElement>(null);

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (!menuRef.current) return;

    switch (e.key) {
      case 'ArrowDown': {
        e.preventDefault();
        focusMenuItem(menuRef.current, 'next');
        break;
      }
      case 'ArrowUp': {
        e.preventDefault();
        focusMenuItem(menuRef.current, 'previous');
        break;
      }
      default:
        break;
    }
  };

  return (
    <div
      role='menu'
      className={cx(
        className,
        'o-menu-content',
        'rounded-x1 border border-solid border-border-primary background-primary p-x1 shadow-l2'
      )}
      onKeyDown={handleKeyDown}
      ref={menuRef}
    >
      {children}
    </div>
  );
};

MenuStatic.displayName = 'MenuStatic';

export default MenuStatic;
